import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-audio-player" }

import AudioWave from "@/components/UI/AudioPlayer/AudioWave.vue";
import AudioPlayerPopup from "@/components/UI/AudioPlayer/AudioPlayerPopup.vue";
import BackgroundAudio from "@/ts/Audio/BackgroundAudio";


export default /*@__PURE__*/_defineComponent({
  __name: 'BackgroundAudioPlayer',
  setup(__props) {

const backgroundAudio = BackgroundAudio.getInstance();
const {isShowedPopup, playerMetadata, isPlaying} = backgroundAudio;
const onClick = () => {
  backgroundAudio.showPopup();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isPlaying))
      ? (_openBlock(), _createBlock(AudioWave, {
          key: 0,
          onClick: onClick
        }))
      : _createCommentVNode("", true),
    (_unref(playerMetadata))
      ? (_openBlock(), _createBlock(AudioPlayerPopup, _mergeProps({
          key: 1,
          show: _unref(isShowedPopup),
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isShowedPopup) ? (isShowedPopup).value = $event : null))
        }, _unref(playerMetadata)), null, 16, ["show"]))
      : _createCommentVNode("", true)
  ]))
}
}

})